module.exports = __webpack_public_path__ + "img/check-circle-icon.svg";